export const blockIconsHomeNestCamIqOutdoorNew = (
	<span className='material-symbols-outlined'>nest_cam_iq_outdoor</span>
);
